import { useContext, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContext } from "../../../../../hooks/context";
import {
  useApproveReturn,
  useRejectReturn,
} from "../../../../../hooks/api/mutations/useInventory";
import { useGetReturnRequestDetails } from "../../../../../hooks/api/queries/useInventory";
import { pathConstants } from "../../../../../routes/pathContants";

const useReturnReview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const triggerToast = useContext(ToastContext);

  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [rejectionReason, setRejectionReason] = useState("");
  const [rejectionError, setRejectionError] = useState("");

  const {
    data: returnDetails,
    isLoading: isLoadingDetails,
    refetch: refetchDetails,
  } = useGetReturnRequestDetails({ id });

  const { mutate: approveMutation, isLoading: isApproving } =
    useApproveReturn();
  const { mutate: rejectMutation, isLoading: isRejecting } = useRejectReturn();

  const handleApprove = () => {
    approveMutation(
      { id },
      {
        onSuccess: (res) => {
          triggerToast(
            res?.data?.detail || "Return request approved successfully.",
            "success",
          );
          setIsApproveModalOpen(false);
          refetchDetails();
        },
      },
    );
  };

  const handleReject = (reason) => {
    const finalReason = typeof reason === "string" ? reason : rejectionReason;
    if (!finalReason.trim()) {
      setRejectionError("Please provide a reason for rejection.");
      return;
    }
    setRejectionError("");

    rejectMutation(
      { id, reason: finalReason.trim() },
      {
        onSuccess: (res) => {
          triggerToast(
            res?.data?.detail || "Return request rejected successfully.",
            "success",
          );
          setIsRejectModalOpen(false);
          setRejectionReason("");
          refetchDetails();
        },
      },
    );
  };

  const handleBack = () => {
    navigate(pathConstants.INVENTORY_RETURNS);
  };

  return {
    id,
    returnDetails,
    isLoadingDetails,
    isApproving,
    isRejecting,
    isApproveModalOpen,
    setIsApproveModalOpen,
    isRejectModalOpen,
    setIsRejectModalOpen,
    rejectionReason,
    setRejectionReason,
    rejectionError,
    setRejectionError,
    handleApprove,
    handleReject,
    handleBack,
    refetchDetails,
  };
};

export default useReturnReview;
